import { compose, withStateHandlers } from "recompose"

const enhance = compose(
  withStateHandlers(
    { isOpen: false, buttonConf: [] },
    {
      toggleOpen: (state, { isOpen }) => () => ({ isOpen: !isOpen }),
      setIsOpen: () => isOpen => ({ isOpen }),
      onCancel: () => () => ({ isOpen: false }),
    },
  ),
)

export default enhance
